import { slug, splitLines } from '../detect.js';
const SECTION_RE = /^\s*section\s+(.+)$/i;
const TASK_RE = /^\s*([^:]+?)\s*:\s*(\d+)\s*(?::\s*(\S+))?\s*$/;
export const parseJourney = (source) => {
    const lines = splitLines(source);
    const nodes = [];
    const groups = [];
    let current = '';
    let idx = 0;
    for (const raw of lines) {
        const line = raw.trim();
        if (!line || /^journey\b/i.test(line))
            continue;
        const sec = SECTION_RE.exec(line);
        if (sec) {
            current = sec[1].trim();
            groups.push({ id: `jsec_${slug(current)}`, label: current, members: [] });
            continue;
        }
        const task = TASK_RE.exec(line);
        if (task) {
            const [, label, score, actor] = task;
            const id = `jt_${idx++}`;
            const node = {
                id,
                label: `${label?.trim() ?? ''}\nscore: ${score}${actor ? ` · ${actor}` : ''}`,
                shape: 'rect',
                parent: `jsec_${slug(current)}`,
            };
            nodes.push(node);
            const grp = groups.find((g) => g.id === `jsec_${slug(current)}`);
            if (grp)
                grp.members.push(id);
        }
    }
    return { type: 'journey', nodes, edges: [], groups, styles: {}, meta: {} };
};
//# sourceMappingURL=journey.js.map